import { Suspense, type JSX } from "react";

import { BreadcrumbSpec } from "@impero-com/common/componentTypes/breadcrumb";
import createIcon from "@impero-com/common/img/create-icon.svg";
import { t } from "@impero-com/common/utils/i18n";
import { ActionSpec, PageSpinner } from "@impero-com/ui";

import { OrgApplicationBar } from "../../../components/applicationBar/orgApplicationBar";
import { LegacyRoute } from "../../../legacyRoutes";
import { WebRoute } from "../../../routes";
import { useClassificationsQuery } from "../queries";

import { ClassificationsList } from "./ClassificationsList";

function ClassificationListPage(): JSX.Element {
    const { data: classiciationsForUser } = useClassificationsQuery();

    return (
        <Suspense fallback={<PageSpinner />}>
            <OrgApplicationBar
                title={buildBreadCrumbs()}
                actions={{
                    id: "action-menu-classification-list",
                    actions: buildActions({
                        canCreateClassification:
                            classiciationsForUser.canCreate,
                    }),
                }}
            >
                <ClassificationsList
                    classifications={classiciationsForUser.classifications}
                />
            </OrgApplicationBar>
        </Suspense>
    );
}

function buildBreadCrumbs(): BreadcrumbSpec {
    return {
        breadCrumbs: [
            {
                label: t("Report_BreadCrumb"),
                url: WebRoute.REPORTS,
            },
            {
                label: t("Report_BreadCrumb_Classification"),
                url: WebRoute.REPORTS_CLASSIFICATION,
            },
        ],
        title: t("Report_BreadCrumb_Classification_Classifications"),
    };
}

interface BuildActionsArgs {
    canCreateClassification: boolean;
}

function buildActions({
    canCreateClassification,
}: BuildActionsArgs): Array<ActionSpec> {
    return [
        {
            id: "action-create-classification",
            label: t("Classification_List_Toolbar_CreateNew"),
            icon: { svg: createIcon },
            link: {
                href: LegacyRoute.CLASSIFICATION_CREATE,
            },
            status: canCreateClassification
                ? { type: "ENABLED" }
                : {
                      type: "DISABLED",
                      reason: t(
                          "Classification_List_Toolbar_CreateNew_Disabled"
                      ),
                  },
        },
    ];
}

export { ClassificationListPage };
